/**
 * Render a search results row
 */
export const renderRow = (heading, data) =>
  heading &&
  data && (
    <tr>
      <th>{heading}</th>
      <td>{data}</td>
    </tr>
  );
